const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const mapOptions: any = {
    googleMapApiKey: GOOGLE_MAPS_API_KEY,
}